import { render, staticRenderFns } from "./VersoCombobox.vue?vue&type=template&id=01398f03&scoped=true"
import script from "./VersoCombobox.vue?vue&type=script&lang=js"
export * from "./VersoCombobox.vue?vue&type=script&lang=js"
import style0 from "./VersoCombobox.vue?vue&type=style&index=0&id=01398f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01398f03",
  null
  
)

export default component.exports